import { useTranslate } from "@similarweb/i18n-provider";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

import FiltersPanelInfoIcon from "app/pages/sales-intelligence/common-components/filters-panel/components/FiltersPanelInfoIcon/FiltersPanelInfoIcon";

import type { RadioGroupFilterModel } from "../../../models/RadioGroupFilterModel";
import type { IFilterViewBaseProps } from "../../../types/filterInstance";

import { StyledRadioGroupItem } from "./styles";

export const RadioGroupFilter = <K extends string>({
    filter,
    value,
    onFilterUpdate,
}: IFilterViewBaseProps<RadioGroupFilterModel<K>>) => {
    const { translate } = useTranslate();

    const currentValue = filter.fromApiValue(value);

    return (
        <Stack gap="8px">
            {filter.options.map((option) => (
                <Flex
                    key={option.key}
                    data-automation={`radio-group-option-${option.key}`}
                    gap="8px"
                    justifyContent="flex-start"
                    alignItems="center"
                >
                    <StyledRadioGroupItem
                        itemLabel={translate(option.label)}
                        itemSelected={option.key === currentValue}
                        onClick={() => onFilterUpdate(option.key)}
                    />

                    {option.tooltip ? <FiltersPanelInfoIcon tooltipText={translate(option.tooltip)} /> : null}
                </Flex>
            ))}
        </Stack>
    );
};
